/* eslint-disable jsx-a11y/media-has-caption */
import type { FC } from 'react';
import {
  Box,
  Container,
  // Typography,
  Button,
  Link,
  Grid,
  Card,
  // Avatar,
  Theme,
  useMediaQuery
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { KumaoTheme } from 'src/theme';
import useSettings from 'src/hooks/useSettings';
import PersonIcon from '@mui/icons-material/Person';
// import BusinessIcon from '@mui/icons-material/Business';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import VisibilityIcon from '@mui/icons-material/Visibility';

interface PromotionVideoProps {}

const PromotionVideo: FC<PromotionVideoProps> = () => {
  const { settings } = useSettings();
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  /* const CustomIcon = (value: { icon: ReactNode }) => {
    const { icon } = value;
    return (
      <Avatar
        sx={{
          height: 42,
          width: 42,
          margin: 0.9,
          bgcolor: 'white',
          color: 'orange'
        }}
      >
        {icon}
      </Avatar>
    );
  };
  */

  return (
    <Box sx={{ backgroundColor: (theme: KumaoTheme) => theme.palette.background.mintgreen }}>
      <Container
        maxWidth={settings.compact ? 'lg' : false}
        sx={{ pt: 0, pb: 5 }}
      >
        <Grid
          container
          spacing={2}
          sx={{ pt: 3 }}
          justifyContent="center"
        >
          {/*
          <Grid
            item
            sm={12}
            md={6}
          >
            <Card
              color="primary"
              sx={{
                flexGrow: 1,
                overflow: 'hidden',
                px: 3,
                pt: 1,
                backgroundColor: (theme: KumaoTheme) => theme.palette.primary.main,
                borderRadius: 5,
                backgroundImage: 'url(/static/home-new/Kumao_24-08_Elemente-02_72ppi.png)',
                backgroundPosition: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 120%',
                minHeight: 415,
                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;',
              }}
            >
              <Box sx={{ my: 1, mx: 'auto', p: 2 }}>
                <Grid
                  container
                  wrap="nowrap"
                  spacing={2}
                >
                  <Grid item>
                    <CustomIcon icon={<BusinessIcon />} />
                  </Grid>
                  <Grid
                    item
                    xs
                    zeroMinWidth
                    sx={{ my: 'auto' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: (theme: KumaoTheme) => theme.palette.secondary.contrastText, fontWeight: 700
                      }}
                    >
                      Zentrale Online-Präsenz
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: (theme: KumaoTheme) => theme.palette.secondary.contrastText, fontWeight: 700
                      }}
                    >
                      Stelle deine Dienstleistungen professionell auf deiner eigenen Profilseite dar – inklusive Bilder, Beschreibungen & Preise.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  my: 1,
                  mx: 'auto',
                  p: 2
                }}
              >
                <Grid
                  container
                  wrap="nowrap"
                  spacing={2}
                >
                  <Grid item>
                    <CustomIcon icon={<CalendarMonthIcon />} />
                  </Grid>
                  <Grid
                    item
                    xs
                    sx={{ my: 'auto' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: (theme: KumaoTheme) => theme.palette.secondary.contrastText, fontWeight: 700
                      }}
                    >
                      Integrierte Terminbuchung
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: (theme: KumaoTheme) => theme.palette.secondary.contrastText, fontWeight: 700
                      }}
                    >
                      Kunden können direkt online Termine bei dir buchen – rund um die Uhr, ganz ohne Hin und Her.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  my: 1,
                  mx: 'auto',
                  p: 2,
                }}
              >
                <Grid
                  container
                  wrap="nowrap"
                  spacing={2}
                >
                  <Grid item>
                    <CustomIcon icon={<VisibilityIcon />} />
                  </Grid>
                  <Grid
                    item
                    xs
                    sx={{ my: 'auto' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: (theme: KumaoTheme) => theme.palette.secondary.contrastText, fontWeight: 700
                      }}
                    >
                      Gezielte Sichtbarkeit
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: (theme: KumaoTheme) => theme.palette.secondary.contrastText, fontWeight: 700
                      }}
                    >
                      Werde auf Kumao von neuen Kund:innen entdeckt – durch Suchfunktionen & Kategorien.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
          */}

          {/* ---------------- second card -------------- */}
          <Grid
            item
            sm={12}
            md={6}
            display="flex"
            justifyContent="center"
          >
            <Card
              color="primary"
              sx={{
                flexGrow: 1,
                overflow: 'hidden',
                px: 3,
                pt: 1,
                backgroundColor: (theme: KumaoTheme) => theme.palette.primary.main,
                borderRadius: 5,
                ...(!sm && { minHeight: 415 }),
                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;',
              }}
            >
              <Box
                sx={{ width: '100%', margin: 'auto' }}
              >
                <Box
                  mt={3}
                  justifyContent="center"
                >
                  <video
                    style={{
                      width: '100%',
                      maxHeight: '100%'
                    }}
                    controls
                    loop
                    muted
                    autoPlay
                    playsInline
                  >
                    <source
                      src="/static/home-new/Kumao_Info_Video.mp4"
                      type="video/mp4"
                    />
                  </video>
                </Box>
              </Box>
              <Box
                mt={3}
                pb={3}
                sx={{ textAlign: 'center' }}
              >
                <Link
                  color="textSecondary"
                  component={RouterLink}
                  to="/register"
                  underline="none"
                >
                  <Button
                    variant="contained"
                    sx={{ minWidth: '80%', borderRadius: 5 }}
                    color="secondary"
                    size="large"
                    startIcon={<PersonIcon />}
                  >
                    Erstelle jetzt Dein kostenloses Konto
                  </Button>
                </Link>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PromotionVideo;
